import styled from 'styled-components';

export const BoxContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1c1c24;
  flex-direction: column;
`;

export const ContentContainer = styled.div`
  width: 23vw;
  display: flex;
  flex-direction: column;
  overflow:hidden;
  background-color: #2C2C38;
  border-radius: 10px;
  padding: 5rem 3.4rem;
  margin-bottom: 1rem;
  @media screen and (max-width: 1440px) and (min-width: 768px) {
    width: 22vw;
    height: 1%;
    padding: 3rem 2.5rem;
  }

  @media screen and (max-width: 1680px) and (min-width: 1440px) {
    width: 23vw;
    height: 60vh;
    height: 1%;
  }

  @media screen and (max-width: 1920px) and (min-width: 1680px) {
    width: 20vw;
    height: 1%;
  }

  @media screen and (min-width: 1920px) {
    width: 20vw;
    height: 1%;
  }

`;

export const BoxHeader = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LogoImage = styled.img`
  width: 40%;
  height: auto;
  display: flex;
`;

export const BoxContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
export const CopyrightBox = styled.div`
  width: auto;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  flex-direction: column;
`;
export const UpperText = styled.p`
  font-size: 1rem;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
  margin-bottom: 1.2rem;
  
  // Large Screens
  @media (max-width: 1440px) {
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
  }
`;
export const Text = styled.p`
  font-size: 1rem;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
  margin-bottom: 0;

  // Large Screens
  @media (max-width: 1440px) {
    font-size: 0.9rem;
  }
`;
